// Manual notes live outside screening results so a fresh search preserves them.
// Only include people in the current screening when displaying or exporting notes.
export function getPepSupportingInformation(form) {
  const screening = form?.internalUse?.pepScreening;
  const subjects = [
    ...(Array.isArray(screening?.searchedSubjects) ? screening.searchedSubjects : []),
    ...(Array.isArray(screening?.result?.subjects) ? screening.result.subjects : []),
  ];
  const notes = form?.pep?.supportingInformation || {};
  const seen = new Set();
  return subjects.flatMap((subject) => {
    const key = subject?.key;
    const text = typeof notes[key] === "string" ? notes[key].trim() : "";
    if (!key || seen.has(key) || !text) return [];
    seen.add(key);
    return [{ key, name: subject.name || "Screened person", text }];
  });
}
